/*

    Module: jv.object-util.service
    Service: ObjectUtil

 */
angular.module('jv.object-util.service', [])
.service('ObjectUtil', [
    function() {
        // return new object without null or undefined properties
        this.removeNullProps = function(obj) {
            var newObj = {};
            Object.keys(obj).forEach(function(prop) {
                if (obj[prop] != null) {
                    newObj[prop] = obj[prop];
                }
            });
            return newObj;
        }
    }
]);